<div #detailsParent class="main-container">
  <div class="row-container top-row">
    <div #leftColumn class="column">
      <mat-card appearance="outlined">
        <mat-toolbar class="section-header" style="margin: 0 16px; padding: 0 16px; width: calc(100% - 32px)">
          <mat-panel-title>
            <h3>Details</h3>
          </mat-panel-title>
        </mat-toolbar>
        <mat-card-content>
          <div class="panel-body">
            <div class="container">
              <div class="cell">
                <div class="title">Title</div>
                <a [routerLink]="['/review/browse']"
                  [queryParams]="{ ProductionJobId: productionJob.productionJobId }">{{productionJob.title}}</a>
              </div>
              <div class="cell">
                <div class="title">{{ isProductionReadOnly() ? 'Run By' : 'Created By' }}</div>
                <div>{{ isProductionReadOnly() && !productionJob.isImportProductionJob ?
                  getUserName(productionJob.runById) : getUserName(productionJob.createdById) }}</div>
              </div>
              <div class="cell">
                <div class="title">Produced Doc Count</div>
                <div>{{ producedDocCount?.toLocaleString() ?? '--' }}</div>
              </div>
              <div class="cell">
                <div class="title">Produced Partially Privileged Doc Count</div>
                <div>{{ partiallyPrivilegedDocCount?.toLocaleString() ?? '--' }}</div>
              </div>
              <div class="cell">
                <div class="title">Withheld Doc Count</div>
                <div>{{ withheldDocCount?.toLocaleString() ?? '--' }}</div>
              </div>
              <div class="cell">
                <div class="title">{{ isProductionReadOnly() ? 'Date Time Run' : 'Date Time Created' }}</div>
                <div>{{ (isProductionReadOnly() && !productionJob.isImportProductionJob ? productionJob.dateTimeRun :
                  productionJob.dateTimeCreated) | date:'M/d/yyyy h:mm:ss a' }}</div>
              </div>
              <div class="cell" style="width:100%">
                <mat-form-field style="width:100%">
                  <mat-label>Comments</mat-label>
                  <textarea matInput placeholder="Comments..." [(ngModel)]="productionJob.comments"
                    (blur)="updateJob(true)"></textarea>
                </mat-form-field>
              </div>
              <div class="cell">
                <button (click)="openSharedSettings()"
                  [disabled]="!this.userConfigService.inRoles(Role.EditFeatureSet)"
                  mat-stroked-button>
                  Manage Share Settings
                  <i class="fa-duotone fa-solid fa-lock" style="margin-left: 4px;"></i>
                </button>
              </div>
              <div class="cell">
                <button (click)="openProductionAuditLog()" mat-stroked-button>
                  Production Share Audits
                  <i class="fa-duotone fa-solid fa-list-timeline" style="margin-left: 4px;"></i>
                </button>
              </div>
              <div *ngIf="sharedProductionLoaded" class="container" class="cell-full-row">
                <div *ngIf="downloadLink"
                  style="display: flex; flex-direction: row; width: 100%;">
                  <mat-form-field>
                    <mat-label>Shared Download Link</mat-label>
                    <input matInput [value]="downloadLink" readonly>
                  </mat-form-field>
                  <button mat-icon-button id="copy-shared-link" color="primary" [cdkCopyToClipboard]="downloadLink"
                    matTooltip="Copy Shared Link" style="margin-left: 10px;">
                    <i class="fa-duotone fa-solid fa-copy icon"></i>
                  </button>
                </div>
              </div>
              <div *ngIf="!sharedProductionLoaded" class="cell cell-full-row">
                <ngx-skeleton-loader count="2" [theme]="{'margin-bottom': '-1px'}"></ngx-skeleton-loader>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div #rigthColumn class="column">
      <mat-card appearance="outlined">
        <mat-toolbar class="section-header" style="margin: 0 16px; padding: 0 16px; width: calc(100% - 32px)">
          <mat-panel-title>
            <h3>Options</h3>
          </mat-panel-title>
        </mat-toolbar>
        <mat-card-content>
          <div class="panel-body">
            <div *ngIf="!isProductionReadOnly()">
              <form [formGroup]="optionsFormGroup" (keyup.enter)="updateJob()" class="container">
                <div class="cell">
                  <div class="info-text">
                    Starting Bates: {{getExampleBateString()}}
                  </div>
                  <br />
                  <mat-form-field>
                    <mat-label>Bates Prefix</mat-label>
                    <input matInput formControlName="batesBasePrefix" required (blur)="updateJob()" />
                    <mat-error *ngIf="optionsFormGroup.controls['batesBasePrefix'].invalid">
                      <p *ngIf="optionsFormGroup.controls['batesBasePrefix'].errors.invalidCharacters">
                        Prefix cannot contain any of the following characters: \/:*?"<>|
                      </p>
                      <p *ngIf="optionsFormGroup.controls['batesBasePrefix'].errors.required">
                        Please fill in Bates Prefix.
                      </p>
                    </mat-error>
                  </mat-form-field>

                </div>
                <div class="cell">
                  <div class="info-text">
                    Valid Range: [1 - {{maxBaseNumberStart()}}]
                  </div>
                  <br />
                  <mat-form-field>
                    <mat-label>Bates Base</mat-label>
                    <input matInput #batesBaseNumberStartInput type="text" formControlName="batesBaseNumberStart"
                      (blur)="syncMask()" />
                    <mat-error *ngIf="optionsFormGroup.controls['batesBaseNumberStart'].invalid">
                      <p *ngIf="optionsFormGroup.controls['batesBaseNumberStart'].errors.max">
                        Bates Number Start must be less than or equal to {{maxBaseNumberStart()}}.
                      </p>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="cell">
                  <mat-form-field>
                    <mat-label>Number of Digits</mat-label>
                    <mat-select formControlName="batesBaseNumberDigits" (blur)="updateJob()">
                      <mat-option [value]="6">6</mat-option>
                      <mat-option [value]="7">7</mat-option>
                      <mat-option [value]="8">8</mat-option>
                      <mat-option [value]="9">9</mat-option>
                      <mat-option [value]="10">10</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="cell align-self-baseline checkbox-align--start">
                  <div style="align-items:baseline"><mat-checkbox formControlName="isBatesStampPages"
                      (change)="updateJob()"> Bates Stamp Page</mat-checkbox></div>
                </div>
                <div class="cell">
                  <mat-form-field>
                    <mat-label>Production Type</mat-label>
                    <mat-select formControlName="isCreateTiff" (selectionChange)="updateJob()">
                      <mat-option [value]="0">Standard</mat-option>
                      <mat-option [value]="1">Standard Plus TIFF</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="cell">
                  <mat-form-field>
                    <mat-label>Custom Designation</mat-label>
                    <input matInput formControlName="customDesignation" (blur)="updateJob()" />
                  </mat-form-field>
                </div>
                <div class="cell align-self-baseline">
                  <button mat-stroked-button (click)="showChooseLoadFileFields(true)">
                    <span *ngIf="loadFileFieldsCustom === 0">
                      Default Load File
                    </span>
                    <span *ngIf="loadFileFieldsCustom === 1">
                      Customized Load File
                    </span>
                    <mat-icon>edit</mat-icon>
                  </button>
                </div>
                <div class="cell">
                  <button *ngIf="sortData" mat-stroked-button (click)="selectSort()">
                    <span style="display: flex; gap: 4px; align-items: center;">
                      <span *ngIf="sortData.first.direction === 'ASC'" style="margin-right: 4px;" matTooltip="Ascending"><i class="fa-regular fa-arrow-up-a-z"></i></span>
                      <span *ngIf="sortData.first.direction === 'DESC'" style="margin-right: 4px;" matTooltip="Descending"><i class="fa-regular fa-arrow-down-z-a"></i></span>
                      <span>{{sortData.firstLevelDisplay}} </span>
                      <span *ngIf="sortData.second.fieldId !== '' && sortData.third.fieldId === ''" [matTooltip]="sortData.secondLevelTooltipDisplay"> +1</span>
                      <span *ngIf="sortData.second.fieldId !== '' && sortData.third.fieldId !== ''" [matTooltip]="sortData.thirdLevelTooltipDisplay"> +2</span>
                    </span>
                  </button>
                  <div *ngIf="!sortData" class="cell cell-full-row">
                    <ngx-skeleton-loader count="1" [theme]="{'margin-bottom': '-1px','height': '34px'}"></ngx-skeleton-loader>
                  </div>
                </div>
                <div class="cell" style="width: 80%;">
                  <mat-checkbox formControlName="isIncludeNativeEmails" (change)="updateJob()"> Include Native
                    Emails.</mat-checkbox>
                  <div class="info-text"><b>Warning.</b> Including native emails can lead to inadvertent disclosure. See
                    Help for more information.</div>
                </div>
              </form>
            </div>
            <div *ngIf="isProductionReadOnly()" class="container read-only">
              <div class="cell">
                <div class="title">Bates Prefix</div>
                <div>{{productionJob.batesBasePrefix}}</div>
                <div class="info-text">
                  Starting Bates: {{getExampleBateString()}}
                </div>
              </div>
              <div class="cell">
                <div class="title">Bates Base</div>
                <div>{{productionJob.batesBaseNumberStart}}</div>
              </div>
              <div class="cell">
                <div class="title">Number of Digits</div>
                <div>{{productionJob.batesBaseNumberDigits}}</div>
              </div>
              <div class="cell">
                <div class="title">Custom Designation</div>
                <div>{{productionJob.customDesignation}}</div>
              </div>
              <div class="cell">
                <div class="title">Production Type</div>
                <div>{{productionJob.isCreateTiff ? 'Standard Plus TIFF' : 'Standard'}}</div>
              </div>
              <div class="cell">
                <div class="title">Bates Stamp Page</div>
                <div><mat-icon>{{productionJob.isBatesStampPages ? 'check' : 'clear'}}</mat-icon></div>
              </div>
              <div class="cell">
                <div class="title">Load File Fields</div>
                <div *ngIf="loadFileFieldsCustom === 0">Default</div>
                <div *ngIf="loadFileFieldsCustom === 1">
                  <button mat-stroked-button (click)="showChooseLoadFileFields(false)">
                    View Load File Fields
                  </button>
                </div>
              </div>
              <div class="cell">
                <div class="title">Sort By</div>
                <div *ngIf="productionJob.sortId && sortData">
                  <div class="list">
                    <div class="list-item">
                      <div mat-line class="item-content">
                        <span *ngIf="sortData.first.direction === 'ASC'" mat-list-icon matTooltip="Ascending"><i
                            class="fa-regular fa-arrow-up-a-z"></i></span>
                        <span *ngIf="sortData.first.direction === 'DESC'" mat-list-icon matTooltip="Descending"><i
                            class="fa-regular fa-arrow-down-z-a"></i></span>
                        <span>{{sortData.first.displayName}}</span>
                      </div>
                    </div>
                    <div *ngIf="sortData.second.fieldId !== ''" style="display: flex; flex-direction: column;">
                      <div class="title">Then By</div>
                      <div class="list-item">
                        <div mat-line class="item-content">
                          <span *ngIf="sortData.second.direction === 'ASC'" mat-list-icon matTooltip="Ascending"><i
                              class="fa-regular fa-arrow-up-a-z"></i></span>
                          <span *ngIf="sortData.second.direction === 'DESC'" mat-list-icon matTooltip="Descending"><i
                              class="fa-regular fa-arrow-down-z-a"></i></span>
                          <span>{{sortData.second.displayName}}</span>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="sortData.third.fieldId !== ''" style="display: flex; flex-direction: column;">
                      <div class="title">Then By</div>
                      <div class="list-item">
                        <div mat-line class="item-content">
                          <span *ngIf="sortData.third.direction === 'ASC'" mat-list-icon matTooltip="Ascending"><i
                              class="fa-regular fa-arrow-up-a-z"></i></span>
                          <span *ngIf="sortData.third.direction === 'DESC'" mat-list-icon matTooltip="Descending"><i
                              class="fa-regular fa-arrow-down-z-a"></i></span>
                          <span mat-line>{{sortData.third.displayName}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="!sortData">
                  <ngx-skeleton-loader count="1" [theme]="{'margin-bottom': '-1px','height': '34px'}"></ngx-skeleton-loader>
                </div>
              </div>
              <div class="cell">
                <div class="title">Include Native Emails</div>
                <div><mat-icon>{{productionJob.isIncludeNativeEmails ? 'check' : 'clear'}}</mat-icon></div>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div class="row-container">
    <div #singleColumn class="column">
      <mat-card appearance="outlined"
        *ngIf="productionJob.status === productionJobRunStatus.Queued || productionJob.status === productionJobRunStatus.Running || productionJob.status === productionJobRunStatus.PostRun">
        <mat-toolbar class='section-header' style="margin: 0 16px; padding: 0 16px; width: calc(100% - 32px)">
          <mat-panel-title>
            <h3>Results</h3>
          </mat-panel-title>
        </mat-toolbar>
        <div
          *ngIf="productionJob.status === productionJobRunStatus.Queued || productionJob.status === productionJobRunStatus.Running"
          class="production-is-processing-message">
          Production is currently processing...
        </div>
        <div *ngIf="productionJob.status === productionJobRunStatus.PostRun">
          <table mat-table [dataSource]="resultTableRows" class="mat-elevation-z0">
            <ng-container matColumnDef="label">
              <th mat-header-cell *matHeaderCellDef class="column-label"></th>
              <ng-container *matCellDef="let element">
                <td mat-cell class="column-label">
                  <div class="results-label">{{element.label}}</div>
                </td>
              </ng-container>
            </ng-container>
            <ng-container matColumnDef="produced">
              <th mat-header-cell *matHeaderCellDef class="column-produced">Produced</th>
              <ng-container *matCellDef="let element">
                <td mat-cell [attr.colspan]="element.partiallyPrivileged ? '1' : '2'" class="column-produced">
                  {{element.produced?.toLocaleString()}}
                </td>
              </ng-container>
            </ng-container>
            <ng-container matColumnDef="partiallyPrivileged">
              <th mat-header-cell *matHeaderCellDef class="column-partially-privileged">Produced Partially Privileged
              </th>
              <ng-container *matCellDef="let element">
                <td mat-cell *ngIf="element.partiallyPrivileged" class="column-partially-privileged">
                  {{element.partiallyPrivileged?.toLocaleString()}}
                </td>
              </ng-container>
            </ng-container>
            <ng-container matColumnDef="withheld">
              <th mat-header-cell *matHeaderCellDef class="column-withheld">Withheld</th>
              <ng-container *matCellDef="let element">
                <td mat-cell [attr.colspan]="element.total ? '1' : '2'" class="column-withheld">{{element.withheld}}
                </td>
              </ng-container>
            </ng-container>
            <ng-container matColumnDef="total">
              <th mat-header-cell *matHeaderCellDef class="column-total">
                Total
              </th>
              <ng-container *matCellDef="let element">
                <td mat-cell *ngIf="element.total" class="column-total">
                  {{element.total?.toLocaleString()}}
                </td>
              </ng-container>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
          </table>
        </div>
      </mat-card>
    </div>
  </div>
</div>
